<template>
  <div v-if="show" class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <button class="close-btn" @click="closeModal">X</button>
      </div>
      <div class="modal-body">
        <p>{{ text }}</p>
      </div>
      <div class="modal-footer">
        <button class="close-btn" @click="closeModal">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    text: String,
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-container {
  z-index: 9999999999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  max-width: 80%;
}

.modal-header {
  display: flex;
  justify-content: flex-end;
}

.close-btn {
  cursor: pointer;
  background: none;
  border: none;
  font-size: 18px;
}

.modal-body {
  text-align: center;
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
